export const Heading = {
  baseStyle: {
    fontWeight: '500',
  },
};
